import { takeEvery, call, put } from 'redux-saga/effects'
import CryptoJS from 'crypto-js'
import { ON_PASSWORD_UPDATE } from '../../constants/employer'
import { API_SERVER } from '../../constants'
import { apiManualPost } from '../../utils/employer/request'
import {
  passwordUpdateSuccess,
  passwordUpdateFailed
} from '../../actions/employer'
import store from '../../store'

/**
 * updatePasswordSaga of employer side is copied from updatePasswordSaga user side
 * if this is updated, let check and done the same things with user side
 */

function* updatePasswordSaga({ formValues }) {
  try {
    const hashedOldPassword = CryptoJS.SHA256(formValues.current_pw).toString()
    const hashedPassword = CryptoJS.SHA256(formValues.new_pw).toString()
    const uuid = store.getState().client.user.data[2]

    const body = JSON.stringify({
      oldpassword: hashedOldPassword,
      password: hashedPassword,
      uuid: uuid
    })

    const url = `${API_SERVER}/UpdateEmployerCredentials`
    const result = yield call(apiManualPost, url, body)
    if (result.data === 'Employer password updated successfully!') {
      yield put(passwordUpdateSuccess(result.data))
    } else {
      yield put(passwordUpdateFailed(result.data))
    }
  } catch (error) {
    yield put(passwordUpdateFailed(error))
  }
}

export function* watchUpdatePasswordSaga() {
  yield takeEvery(ON_PASSWORD_UPDATE, updatePasswordSaga)
}
